import React from "react";

interface BadgeProps {
  text: string;
  imageStyle?: string;
  textStyle?: string;
  badgeImage: string;
}

const Badge: React.FC<BadgeProps> = ({
  text,
  badgeImage,
  textStyle,
  imageStyle,
}) => {
  const badgeImageStyle = `bg-transparent h-4 w-4 ${imageStyle}`;
  const badgeTextStyle = `
        leading-3
        pl-1/2
        text-gray-800
        font-semibold
        text-xs
        mb-0
        whitespace-nowrap
        underline
        hover:no-underline
        ${textStyle}
    `;
  return (
    <>
      <img
        className={badgeImageStyle}
        src={badgeImage}
        alt=""
        data-testid={text}
      />
      <p
        className={`${badgeTextStyle} badgeText`}
        data-testid={`badge-${text}`}
      >
        {text}
      </p>
    </>
  );
};

export default React.memo(Badge);
